import { CommonModule } from '@angular/common';
import { Component, OnInit} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import {environment} from '@environmentsenvironment';


@Component({
  selector: 'app-sibe-bar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sibe-bar.component.html',
  styleUrl: './sibe-bar.component.css'
})
export class SibeBarComponent implements OnInit {
  store = environment.store;
  manageThemes = environment.manageThemes;

 constructor(private router:Router){}

 isuserSectionActive():boolean{
  return this.router.url.startsWith('/potal/user');
 }

  ngOnInit(): void {}

}
